import React from 'react';
import './Message.scss';

const Message = ({ displayMessage, type }) => (
  <div className={`message-wrapper ${type}`}>
    <div className="message">{displayMessage}</div>
  </div>
);

export default Message;
